import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "../styles.css";

export function ImageCarousel({ photo, photos }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [currentImage, setCurrentImage] = useState(
    `${process.env.REACT_APP_API_URL}/api/v1/property/${(photo?.image_url).replace("/photos/", "")}`,
  );
  const [activeThumb, setActiveThumb] = useState(0);

  const handleThumbClick = (imageUrl, index) => {
    setCurrentImage(imageUrl);
    setActiveThumb(index);
  };

  const downloadImage = (imageUrl) => {
    fetch(imageUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const filename = imageUrl.split("/").pop();
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.error("Ошибка скачивания изображения: ", err));
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <Swiper
          modules={[Thumbs, Navigation]}
          navigation={true}
          thumbs={{ swiper: thumbsSwiper }}
          onSlideChange={(swiper) => {
            const newImage = `${process.env.REACT_APP_API_URL}/api/v1/property/${photos[swiper.activeIndex]?.image_url.replace("/photos/", "")}`;
            setCurrentImage(newImage);
            setActiveThumb(swiper.activeIndex);
          }}
          className="mySwiper2"
        >
          {photos.map((item, index) => (
            <SwiperSlide key={index}>
              <img
                src={`${process.env.REACT_APP_API_URL}/api/v1/property/${item?.image_url.replace("/photos/", "")}`}
                alt="object"
              />
            </SwiperSlide>
          ))}
        </Swiper>

        <img
          src="/icons/loadImage.svg"
          alt="Скачать"
          className="downloadIcon"
          onClick={() => downloadImage(currentImage)}
        />
      </div>

      <Swiper
        spaceBetween={10}
        slidesPerView={4}
        freeMode={true}
        modules={[Thumbs]}
        watchSlidesProgress
        onSwiper={setThumbsSwiper}
        className="mySwiper"
      >
        {photos.map((item, index) => (
          <SwiperSlide key={index}>
            <img
              src={`${process.env.REACT_APP_API_URL}/api/v1/property/${item?.image_url.replace("/photos/", "")}`}
              alt="object"
              onClick={() =>
                handleThumbClick(
                  `${process.env.REACT_APP_API_URL}/api/v1/property/${item?.image_url.replace("/photos/", "")}`,
                  index,
                )
              }
              className={`thumb-image ${activeThumb === index ? "active" : ""}`}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}
